<template>
  <div>
    <div class="contents">
      <b-form @submit="onSubmit">
        <div class="filter-box-2">
          <div>
            <select class="form-select-lg" v-model="searchData.searchtype">
              <option value="1">{{ $t("filter.common.title") }}</option>
              <option value="2">{{ $t("filter.common.contents") }}</option>
            </select>
          </div>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="searchData.searchname"
            />
            <button
              class="btn btn-primary btn-lg icon-search"
              type="submit"
              value=""
            ></button>
          </div>
        </div>
      </b-form>

      <table class="table board resrc-list">
        <thead>
          <tr>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.number") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.category") }}
            </th>
            <th class="col-auto">{{ $t("title.common.title") }}</th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.date") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.view_count") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.status") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.note") }}
            </th>
            <th class="th-arrow"></th>
          </tr>
        </thead>
        <tbody v-if="data_yn">
          <template v-for="(item, index) in items">
            <tr :key="index">
              <td class="col-auto d-none d-lg-table-cell">{{ item.no }}</td>
              <td class="col-auto d-none d-lg-table-cell">
                <span class="icon badge bg-purple" v-if="item.type == 1">
                  {{ item.type | category("list") }}
                </span>
                <span class="icon badge bg-blue" v-if="item.type == 2">
                  {{ item.type | category("list") }}
                </span>
                <span class="icon badge bg-pink" v-if="item.type == 3">
                  {{ item.type | category("list") }}
                </span>
                <span class="icon badge bg-cyan" v-if="item.type == 4">
                  {{ item.type | category("list") }}
                </span>
              </td>
              <td class="col-auto text-start">
                <div class="d-flex align-items-center">
                  <router-link
                    :to="{
                      name: 'ResourcesView',
                      params: { resourcesno: item.resourcesno },
                      query: {
                        searchtype: searchData.searchtype,
                        searchname: searchData.searchname,
                      },
                    }"
                    class="text-truncate more"
                  >
                    {{ item.title }}
                  </router-link>
                  <img
                    src="/img/icon_new.gif"
                    v-if="$dayjs().diff(item.timezone_date, 'day') < 8"
                    class="ms-1"
                  />
                </div>
              </td>
              <td class="col-auto d-none d-lg-table-cell text-date">
                {{ item.timezone_date | dateformat }}
              </td>
              <td class="col-auto d-none d-lg-table-cell">
                {{ item.cnt | comma }}
              </td>
              <td class="col-auto d-none d-lg-table-cell">
                <label class="status-pend min-w-64px" v-if="item.status == '0'">
                  {{ $t("filter.support.pending") }}
                </label>
                <label
                  class="status-done min-w-64px"
                  v-else-if="item.status == '1'"
                >
                  {{ $t("filter.support.post") }}
                </label>
                <label v-else>-</label>
              </td>
              <td class="col-auto d-none d-lg-table-cell fs-14">
                <label class="text-green" v-if="item.deleteflag === '0'">
                  {{ $t("filter.support.ok") }}
                </label>
                <label
                  class="text-danger text-opacity-75"
                  v-else-if="item.deleteflag === '1'"
                >
                  {{ $t("filter.common.delete") }}
                </label>
                <label v-else>-</label>
              </td>
              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="col-auto d-lg-none d-md-tabel-cell"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td class="text-start" colspan="7">
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.number") }}</div>
                    <div class="col-6">{{ item.no }}</div>
                  </div>
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.category") }}</div>
                    <div class="col-6">
                      <span class="icon badge bg-purple" v-if="item.type == 1">
                        {{ item.type | category("list") }}
                      </span>
                      <span class="icon badge bg-blue" v-if="item.type == 2">
                        {{ item.type | category("list") }}
                      </span>
                      <span class="icon badge bg-pink" v-if="item.type == 3">
                        {{ item.type | category("list") }}
                      </span>
                      <span class="icon badge bg-cyan" v-if="item.type == 4">
                        {{ item.type | category("list") }}
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.date") }}</div>
                    <div class="col-6 text-date">
                      {{ item.timezone_date | dateformat }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      {{ $t("title.common.view_count") }}
                    </div>
                    <div class="col-6">{{ item.cnt | comma }}</div>
                  </div>
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.status") }}</div>
                    <div class="col-6">
                      <label
                        class="status-pend min-w-64px"
                        v-if="item.status == '0'"
                      >
                        {{ $t("filter.support.pending") }}
                      </label>
                      <label
                        class="status-done min-w-64px"
                        v-else-if="item.status == '1'"
                      >
                        {{ $t("filter.support.post") }}
                      </label>
                      <label v-else>-</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.note") }}</div>
                    <div class="col-6 fs-14">
                      <label class="text-green" v-if="item.deleteflag === '0'">
                        {{ $t("filter.support.ok") }}
                      </label>
                      <label
                        class="text-danger text-opacity-75"
                        v-else-if="item.deleteflag === '1'"
                      >
                        {{ $t("filter.common.delete") }}
                      </label>
                      <label v-else>-</label>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="7" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="page_total"
        v-model="searchData.pageno"
        use-router
        :aria-label="$t('text.common.pagination')"
        v-if="page_total > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text>
          <i class="material-icons">keyboard_double_arrow_left</i>
        </template>
        <template #prev-text>
          <i class="material-icons">navigate_before</i>
        </template>
        <template #next-text>
          <i class="material-icons">navigate_next</i>
        </template>
        <template #last-text>
          <i class="material-icons">keyboard_double_arrow_right</i>
        </template>
        <template #page="{ page, active }">
          <div v-if="active">{{ page }}</div>
          <div v-else>{{ page }}</div>
        </template>
      </b-pagination-nav>

      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="primary"
          :aria-label="$t('button.common.write')"
          @click="$router.push({ name: 'ResourcesWrite' })"
          >{{ $t("button.common.write") }}</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/support";
import { myMixin } from "@/mixin/myMixin";

export default {
  name: "ResourcesList",

  data() {
    return {
      searchData: {
        searchtype:
          this.$route.query.searchtype ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchtype) ||
          1,
        searchname:
          this.$route.query.searchname ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchname) ||
          "",
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
      },
      page_total: 1,
      total_cnt: 0,
      data_yn: true,
      rows: 10,
      items: [],
      view_hide: null,
    };
  },
  watch: {
    "searchData.searchtype": function () {
      this.searchData.pageno = 1;
      this.getList();
    },
    "searchData.searchname": function () {
      this.searchData.pageno = 1;
      this.getList();
    },
    "searchData.pageno": function () {
      this.getList();
    },
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      this.getList();
    },
    getList() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.getResourceslist(this.searchData, (flag, data, code) => {
        console.log(flag, data);
        if (flag) {
          if (data.resourceslistcnt <= 0) {
            this.data_yn = false;
          } else {
            this.data_yn = true;
          }
          this.total_cnt = data.resourceslistcnt;
          this.page_total = Math.ceil(data.resourceslistcnt / this.rows);
          this.items = data.resourceslist;
        } else {
          this.data_yn = false;
          this.page_total = 0;
          if (code === 300) {
            this.$notify({
              group: "alert",
              type: "warn",
              text: data,
            });
          } else alert(data);
        }
      });
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
  created() {
    this.getList();
  },
  mixins: [myMixin],
};
</script>
